export default "__VITE_ASSET__Joo36S9J__"